import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Define the base API
export const userApi = createApi({
  baseQuery: baseQuery(),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUser: builder.query({
      query: () => ({
      url: `/user/me`,
      }),
    }),
    // Every member of the caller's own tenant, including pending invitees
    // (those come back with role: null and no profile/storageUsage).
    getTenantMembers: builder.query({
      query: () => ({
        url: `/tenant/current/users`,
      }),
      providesTags: ['User'],
    }),
    updateUserRole: builder.mutation({
      query: ({ id, role }) => ({
        url: `/user/${id}`,
        method: 'PUT',
        body: { role },
      }),
      invalidatesTags: ['User'],
    }),
    // Deletes a non-active member, or revokes a pending invite — the backend
    // picks the branch from the target's tenant and status.
    removeUser: builder.mutation({
      query: (id) => ({
        url: `/user/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
    activateUser: builder.mutation({
      query: (id) => ({
        url: `/user/activate/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['User'],
    }),
    deactivateUser: builder.mutation({
      query: (id) => ({
        url: `/user/deactivate/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetUserQuery,
  useGetTenantMembersQuery,
  useUpdateUserRoleMutation,
  useRemoveUserMutation,
  useActivateUserMutation,
  useDeactivateUserMutation,
} = userApi;